import { OFFERINGS_DATA, OFFERINGS_SET_ERROR, OFFERINGS_HIDE_ERROR, OFFERINGS_START_LOADER, OFFERINGS_STOP_LOADER, } from "./../../interfaces/Home/iAllOfferings";
const initialState = {
    data: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const allOfferings = (state = initialState, action) => {
    switch (action.type) {
        case OFFERINGS_DATA:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case OFFERINGS_SET_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case OFFERINGS_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case OFFERINGS_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case OFFERINGS_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default allOfferings;
